import { createAsyncThunk } from '@reduxjs/toolkit';
import tourneysRepository from 'modules/tournaments/domain/repositories/tourneys-repository';
import { FetchChampionshipsRequestDto } from 'modules/tournaments/domain/interfaces/request-dto';
import { Championship } from 'modules/tournaments/domain/interfaces/responce-dto';
import { RootState } from 'store/store';
import { makeScopeKey, shouldFetchMore } from 'shared/utils/pagination';

const PREFIX = 'tournaments';

// Базовый фетч оставляем для обратной совместимости (если где-то используется)
export const fetchChampionships = createAsyncThunk<Championship[], FetchChampionshipsRequestDto>(
  `${PREFIX}/fetchChampionships`,
  async (payload, { rejectWithValue }) => {
    try {
      const result = await tourneysRepository.fetchChampionships(payload);
      return result ?? [];
    } catch (error) {
      console.error(`${PREFIX}/fetchChampionships error:`, error);

      let message;
      if (error instanceof Error) message = error.message;
      else message = String(error);
      return rejectWithValue(message);
    }
  },
);

// Ленивый фетч и аппенд для championships
export const fetchAndAppendChampionships = createAsyncThunk(
  `${PREFIX}/fetchAndAppendChampionships`,
  async (
    args: { scopeKey: string; tournamentId: number; offset: number; limit: number; beforeDate?: string; afterDate?: string; namePart?: string },
    { rejectWithValue },
  ) => {
    try {
      const { scopeKey, tournamentId, offset, limit, beforeDate, afterDate, namePart } = args;
      const batch = await tourneysRepository.fetchChampionships({
        tournamentId,
        offset,
        limit,
        beforeDate,
        afterDate,
        namePart,
      });
      return { scopeKey, batch, limit } as const;
    } catch (error) {
      console.error(`${PREFIX}/fetchAndAppendChampionships error:`, error);
      let message;
      if (error instanceof Error) message = error.message;
      else message = String(error);
      return rejectWithValue(message);
    }
  },
);

// Обеспечить наличие данных для заданной страницы: при необходимости догружает следующую пачку
export const ensureChampionshipsPage = (
  params: { tournamentId: number; page: number; perPage: number; beforeDate?: string; afterDate?: string; namePart?: string; scopeParts?: Record<string, any> },
) =>
  async (dispatch: any, getState: () => RootState) => {
    const { tournamentId, page, perPage, beforeDate, afterDate, namePart, scopeParts } = params;
    const scopeKey = makeScopeKey({ entity: 'championships', tournamentId, beforeDate, afterDate, namePart, ...(scopeParts || {}) });

    const state = getState();
    const dict = state.tournaments.paged.championships;

    if (!shouldFetchMore(dict, scopeKey, page, perPage)) {
      return; // данных достаточно для отображения нужной страницы
    }

    const scope = dict.scopes[scopeKey];
    const offset = scope?.nextOffset ?? 0;
    const limit = perPage;

    await dispatch(
      fetchAndAppendChampionships({ scopeKey, tournamentId, offset, limit, beforeDate, afterDate, namePart }) as any,
    );
  };
